<template>
  <div class="h-dialogContainer">
    <div class="row">
      <div class="col-sm-4">
        <div class="h-borderBox height-400">
          <div class="h-borderTree-top">{{$t('Pm.selectResource')}}</div>
          <div class="h-borderTree-content">
            <NeTreeForDataSearch ref="NeTreeForDataSearch" :checkedNodesOfNeTree='checkedNodesOfNeTree'></NeTreeForDataSearch>
          </div>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="h-borderBox height-400">
          <div class="h-borderTree-top">{{$t('Pm.selectIndicator')}}</div>
          <div class="h-borderTree-content">
            <MeasureTreeForDataSearch ref="MeasureTreeForDataSearch" :checkedNodesOfMeasureTree='checkedNodesOfMeasureTree'></MeasureTreeForDataSearch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NeTreeForDataSearch from '../tree/NeTreeForDataSearch';
import MeasureTreeForDataSearch from '../tree/MeasureTreeForDataSearch';


export default {
  name: 'NoRealQuerySearchDialog1.vue',
  props: [
    'nodeData',
    'checkedNodesOfNeTree',
    'checkedNodesOfMeasureTree'
  ],
  components: {
    NeTreeForDataSearch,
    MeasureTreeForDataSearch
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {}
};
</script>

<style>

</style>
